export const PRODUCT_BRIEF_CLASS_NAMES = Object.freeze({
    GRID_ITEM_CLASS_NAME: 'js-grid-item',
    COLUMN_WIDTH_SELECTOR: 'js-grid-column-width'
});

export enum TIME_DURATION {
    DEFER_RESET_HEIGHT_VALUE = 100,
    TRANSITION_DURATION = 0
}
